import { BaseSchemaSetting, ElementControlType, WidgetConfiguration } from './types';
import { parseConditionalDefaults } from './conditionalParser';
import { parseRegExPatternsDefaults } from './regexParser';

export function buildSettingsDefaults(settings: BaseSchemaSetting[]): WidgetConfiguration {
    let configuration: WidgetConfiguration = {};

    settings.forEach((setting: BaseSchemaSetting) => {
        if (setting.typeMeta) {
            if (setting.typeMeta.conditionalSettings) {
                const parsedDefaults = parseConditionalDefaults(setting.typeMeta.conditionalSettings);

                configuration = {
                    ...configuration,
                    ...parsedDefaults,
                };
            }

            if (setting.typeMeta.controls) {
                const parsedDefaults = parseElementDefaults(setting.typeMeta.controls);

                configuration = {
                    ...configuration,
                    ...{
                        [setting.id]: parsedDefaults,
                    },
                };
            }

            if (setting.typeMeta.regExPatterns) {
                const parsedDefaults = parseRegExPatternsDefaults(
                    setting.id,
                    setting.default,
                    setting.typeMeta.regExPatterns,
                );

                configuration = {
                    ...configuration,
                    ...parsedDefaults,
                };
            }
        }

        if (setting.default) {
            configuration[setting.id] = setting.default;
        }
    });

    return configuration;
}

function parseElementDefaults(controls: ElementControlType) {
    const elementConfigurations = {};
    Object.keys(controls).forEach((control) => {
        const content = controls[control];
        if (content && content.settings) {
            content.settings.forEach((setting: BaseSchemaSetting) => {
                elementConfigurations[setting.id] = setting.default;
            });
        } else {
            elementConfigurations[control] = content.default;
        }
    });

    return elementConfigurations;
}
